import { render, staticRenderFns } from "./BodyParts.vue?vue&type=template&id=22c028f1&scoped=true"
import script from "./BodyParts.vue?vue&type=script&lang=js"
export * from "./BodyParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c028f1",
  null
  
)

export default component.exports